// extracted by mini-css-extract-plugin
export default {"container":"PetCat_container__crOHm","minimized":"PetCat_minimized__6jbJq","canvas":"PetCat_canvas__J5Hxs","name":"PetCat_name__X0qU8","toggleBtn":"PetCat_toggleBtn__CJNsS"};